/*
 * @Author: 丨小小风离丨
 * @Date: 2024-04-23 19:16:48
 * @LastEditTime: 2025-02-27 19:11:47
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\teachins\list\registerPop.tsx
 * @Description: 
 */
import AntdCropper from "@/components/antdCropper";
import { CommmonGet, CommonUpFile } from "@/util/network/api";
import { baseURL } from "@/util/network/axios";
import { CheckIdCard, CheckPhone, beforeuploadImage, uploadparams } from "@/util/public";
import { Form, Space, Spin, Upload, message } from "antd";
import { LgDrawer, LgInput, LgSelect, lgAlert } from "lancoo-web-ui";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import RsmSelect from "@/components/lg_select";
import './registerPop.scss';
import { genderList, typeList } from "../data";
import { service } from "@/page/userMaage/data";
import { useSelector } from "react-redux";
import { selectUserId } from "../../../store/reducers/userInfo";
import { useNavigate } from "react-router-dom";
import PlanDetail from "@/page/hearder/menuPop/list/enroll/planDetail";
import { selectSchoolId } from "../../../store/reducers/schoolInfo";


const RegisterPop = forwardRef((props: any, ref: any) => {

    const {
        popData,
        popDetailsFlag,
        enterType = false,
        setPopLayer
    } = props;

    const serviceRegisterPop = {
        getMyTeachInBasic: '/common/getMyTeachInBasic',
        detail: '/portal/homepage/planDetail'
    }

    const navigate = useNavigate();
    const userId = useSelector(selectUserId);
    const schoolId = useSelector(selectSchoolId);

    const [form] = Form.useForm();
    const [isloading, setIsloading] = useState<boolean>(false);
    const [planLoading, setPlanLoading] = useState<boolean>(false);

    // 显示图片
    const [covermsg, setcovermsg] = useState<any>(null);

    // 倒计时秒数
    const [countdown, setCountdown] = useState<number>(60);
    const [timingShow, setTimingShow] = useState<boolean>(false);

    // 源图片
    const [orifile, setoriFile] = useState<any>(null);
    const [blod, setblod] = useState<any>(null);
    // 是否启用裁剪功能
    const [crovisble, setcrovisble] = useState<boolean>(false)
    // 拆建的图片Src
    const [ImgSrc, setImgSrc] = useState<any>(null);
    // 详情信息
    const [details, setdetails] = useState<any>(null);
    const [popLayer01, setPopLayer01] = useState<boolean>(false);
    const [planData, setplanData] = useState<any>({});

    useImperativeHandle(ref, () => ({
        form,
        setIsloading
    }));

    /**
    * @description: 获取注册验证码
    * @param {*} void
    * @return {*}
    */
    const getLoginCode = (): void => {
        // 禁用获取验证码按钮
        const formData = form.getFieldsValue();
        if (formData.phone) {
            if (!CheckPhone(formData.phone)) {
                message.warning('手机号格式有误', 2);
                return;
            }
            setIsloading(true);
            CommmonGet(service.sendLoginSmsCode, {
                phone: formData.phone,
                type: 7
            }).then(res => {
                message.success("发送成功");
                startCountdown();
            }).catch(err => {
            }).finally(() => {
                setIsloading(false);
            });
        } else {
            message.warning('请输入手机号', 2);
        }
    };
    /**
    * @description: 倒计时
    * @return {*}
    */
    const startCountdown = () => {
        setTimingShow(true)
        let timer = setInterval(() => {
            setCountdown(prevCountdown => prevCountdown - 1);
        }, 1000);

        setTimeout(() => {
            setTimingShow(false)
            clearInterval(timer);
            setCountdown(60); // 重置倒计时秒数为60
        }, countdown * 1000);
    };

    const handleBeforeUpload = (file: any, fileList: any[]): any => {
        let limtUp = beforeuploadImage(file)
        if (limtUp != true) {
            return limtUp
        }
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
            setoriFile(file);
            setImgSrc(e.target.result);
            setcrovisble(true);
        }
        return new Promise((resolve, reject) => {
            let index = setInterval(() => {
                if (blod) {  // 监听裁剪是否完成
                    window.clearInterval(index);
                    blod.uid = file.uid;   // 须要给裁剪后的blob对象设置uid，不然会报错！！！
                    resolve(blod);   // 执行后续的上传操作
                }
            }, 100);
        });
    };
    const uploaddone = (info: any, type?: any) => {
        if (info.file.status === 'done') {
            const res = info.file.response
            if (res.status !== 0) {
                message.warning(res.msg)
            } else {
                switch (type) {
                    case 1:
                        // 封面
                        let coverobj = {
                            originalName: res.data.originalName,
                            resId: res.data.resId,
                            url: res.data.preUrl
                        }
                        setcovermsg(coverobj)
                        break;
                    case 2:
                        // 资料文件
                        let enclosurebj = {
                            originalName: res.data.originalName,
                            path: res.data.path,
                            resId: res.data.resId,
                            url: res.data.preUrl,
                            size: res.data.fileSize
                        }
                        break;
                    default:
                        break;
                }
            }
        }
    }
    const UpImage = (file, callback) => {
        CommonUpFile('/common/uploadFile', file).then((res: any) => {
            let coverobj = {
                originalName: res.data.originalName,
                resId: res.data.resId,
                url: res.data.preUrl
            }
            setcovermsg(coverobj);
            form.setFieldValue('avatarId', coverobj?.resId);
            if (callback) {
                callback()
            }
        }).catch((err: any) => {
            message.error(err.msg || err.message || '上传失败！')
        })
    }



    useEffect(() => {
        if (popDetailsFlag && popData) {
            CommmonGet(serviceRegisterPop.getMyTeachInBasic, { userId, teachInId: popData.id }).then((res: any) => {
                setdetails(res?.data || {})
            }).catch((err: any) => {
                message.error(err.msg || err.message || '获取失败！')
            })
        }
    }, [popDetailsFlag])

    return (
        <div className="registerPop wjz_spin_div">
            <Spin spinning={isloading}>
                <Form
                    form={form}
                    className={"createteachin " + (popDetailsFlag ? "createteachin_details" : "")}
                    labelCol={{ span: popDetailsFlag ? enterType ? 7 : 5 : 4 }}
                    wrapperCol={{ span: 20 }}
                    labelAlign={popDetailsFlag ? enterType ? "right" : "right" : "right"}
                >
                    <Form.Item
                        label="照片:"
                        name={"avatarId"}
                        className="coverImg"
                        initialValue={""}
                        style={{ marginBottom: popDetailsFlag ? 5 : 10 }}
                        // getValueFromEvent={normPic}
                        rules={[{
                            required: !popDetailsFlag,
                            message: '请上传照片!'
                        }]}
                    >
                        <div style={{ display: "flex", }}>
                            {popDetailsFlag ? <img src={details?.avatar?.[0]?.url || popData?.coverImgs?.[0]?.url || ""} width={85} height={85} /> : <>
                                <Upload
                                    action={baseURL + "/common/uploadFile"}
                                    headers={{ schoolid: schoolId}}
                                    maxCount={1}
                                    data={(file) => uploadparams(file, "image_file")}
                                    accept="image/*"
                                    showUploadList={false}
                                    // beforeUpload={beforeuploadImage}
                                    beforeUpload={handleBeforeUpload}
                                    onChange={file => {
                                        uploaddone(file, 1)
                                    }}
                                >
                                    {
                                        covermsg ?
                                            <div
                                                className="bgImg"
                                                style={{
                                                    height: 85, width: 85, cursor: "pointer",
                                                    background: `url(${covermsg.url}) no-repeat center`,
                                                }}>
                                                <div
                                                    className="chooseImg">选择图片</div>
                                            </div> :
                                            <div className="uploadcover"></div>
                                    }
                                </Upload>
                                <div style={{ color: "#c1c1c1", fontSize: "12px", paddingLeft: "5px", height: "64px", width: "300px", position: "relative" }}>
                                    <p style={{ position: "absolute", bottom: "0", marginLeft: 6, marginBottom: "0px" }}>
                                        上传要求:2M以内JPG/JPEG/GIF/BP/PNG格式。
                                    </p>
                                </div>
                            </>}
                        </div>
                    </Form.Item>
                    <Form.Item
                        label={'姓名'}
                        name={"name"}
                        rules={[{
                            required: !popDetailsFlag,
                            message: ''
                        }]}
                        style={{ marginBottom: popDetailsFlag ? 2 : 10 }}
                    >
                        <Space style={{ alignItems: 'baseline', width: '100%' }}>
                            <Form.Item
                                name={"name"}
                                initialValue={""}
                                rules={[{
                                    required: !popDetailsFlag,
                                    message: '请输入您的姓名'
                                }]}
                                className="item_name"
                                style={{ marginBottom: 0, marginRight: 20 }}
                            >
                                {popDetailsFlag ?
                                    <div style={{ minWidth: enterType ? '120px' : '150px' }}>{details?.tibName}</div>
                                    : <LgInput
                                        size="default"
                                        maxLength={8}
                                        displayNumberOfNumericWords
                                        autoComplete='off'
                                        className=""
                                        placeholder={`请输入您的姓名...`}
                                    />}
                            </Form.Item>
                            <Form.Item
                                label="性别"
                                name={"gender"}
                                initialValue={genderList[0].text}
                                className="item_gender"
                                style={{ marginBottom: 0 }} // 调整性别表单项样式，移除底部间距
                            >
                                {popDetailsFlag ?
                                    <div>{genderList.find(ele => ele.Info === details?.tibGender)?.text}</div>
                                    : <RsmSelect
                                        className='CommonSelect'
                                        change={(value: any) => {
                                            form.setFieldValue('gender', genderList[value].text)
                                        }}
                                        list={genderList.map(ele => ele.text)}
                                        width={100}
                                    />}
                            </Form.Item>
                        </Space>
                    </Form.Item>
                    <Form.Item
                        label="身份证号"
                        name={"idCard"}
                        style={{ marginBottom: popDetailsFlag ? 2 : 10 }}
                        rules={[
                            {
                                required: !popDetailsFlag,
                                message: '身份证号不能为空!'
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || !CheckIdCard(value)) {
                                        return Promise.resolve();
                                    } else if (value && CheckIdCard(value)) {
                                        return Promise.reject(new Error(CheckIdCard(value)));
                                    }
                                    return Promise.reject(new Error('身份证格式有误'));
                                },
                            }),
                        ]}
                    >
                        <Space style={{ alignItems: 'baseline' }}>
                            <Form.Item
                                name={"idCard"}
                                initialValue={""}
                                // className="item_name"
                                style={{ marginRight: 20 }}
                            >
                                {popDetailsFlag ?
                                    <div style={{ minWidth: enterType ? '120px' : '150px' }}>{details?.tibIdCard}</div>
                                    : <LgInput
                                        size="default"
                                        maxLength={18}
                                        // displayNumberOfNumericWords
                                        className=""
                                        placeholder={`请输入您的身份证号...`}
                                    />}
                            </Form.Item>
                            <Form.Item
                                label="身份"
                                name={"type"}
                                initialValue={typeList[0].text}
                            >
                                {popDetailsFlag ?
                                    <div style={{ minWidth: enterType ? '120px' : '150px' }}>{typeList.find(ele => ele.Info === details?.tibType)?.text}</div>
                                    : <RsmSelect
                                        className='CommonSelect'
                                        change={(value: any) => {
                                            form.setFieldValue('type', typeList[value].text)
                                        }}
                                        list={typeList.map(ele => ele.text)}
                                        width={100}
                                    />}
                            </Form.Item>
                        </Space>
                    </Form.Item>
                    <Form.Item
                        label="所属招生计划"
                        name={"planName"}
                        initialValue={""}
                        style={{ marginBottom: popDetailsFlag ? 2 : 10 }}
                    >
                        <div className='onclik_cls' onClick={() => {
                            // if (popData?.planId) {
                            //     // 获取 <html> 标签
                            //     const htmlTag = document.querySelector('html');
                            //     // 直接修改样式属性
                            //     htmlTag.style.overflow = 'unset';
                            //     navigate(`/enrollPlan/details?planId=${popData.planId}`);
                            //     setPopLayer && setPopLayer(false);
                            // }
                            setPopLayer01(true);
                            setPlanLoading(true);
                            CommmonGet(serviceRegisterPop.detail, { planId: popData?.planId, addPageView: false }).then((res: any) => {
                                setplanData(res?.data || {});
                            }).catch(error => {
                                message.destroy();
                                error?.msg && message.error(error.msg);
                            }).finally(() => { setPlanLoading(false); })

                        }}>{popData?.planName || ''}</div>
                    </Form.Item>
                    <Form.Item
                        label="手机号码"
                        name={"phone"}
                        initialValue={""}
                        rules={[
                            {
                                required: !popDetailsFlag,
                                message: '请输入手机号码'
                            }
                        ]}
                    >
                        {popDetailsFlag ?
                            <div style={{ minWidth: enterType ? '120px' : '150px' }}>{details?.tibMobile}</div>
                            : <LgInput
                                size="default"
                                maxLength={11}
                                // displayNumberOfNumericWords
                                className=""
                                placeholder={`请输入您的手机号...`}
                            />}
                    </Form.Item>
                    {!popDetailsFlag && <Form.Item
                        label="验证码"
                        className='form_icon'
                        rules={[
                            {
                                required: !popDetailsFlag,
                                message: '请输入验证码'
                            }
                        ]}
                    >
                        <Form.Item
                            name="code"
                            rules={[{ required: !popDetailsFlag, message: '请输入验证码' }]}
                            className="item_code"
                        >
                            <LgInput
                                size="default"
                                // bigWidth
                                maxLength={10}
                                style={{ width: 220 }}
                                input={{ placeholder: "请输入验证码" }}
                            />
                        </Form.Item>
                        {timingShow ?
                            <div
                                className='form_ss'
                                style={{
                                    color: '#999999',
                                    cursor: 'default'
                                }}
                            >
                                ({countdown}秒后重新获取)
                            </div> :
                            <span
                                className='onclik_cls'
                                onClick={getLoginCode}
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 140,
                                    right: '20px',
                                    display: 'table',
                                    lineHeight: '32px'
                                }}
                            >
                                获取验证码
                            </span>
                        }
                    </Form.Item>}
                    {/* <Form.Item
                        label="验证码"
                        name={"type"}
                        initialValue={""}
                    ></Form.Item> */}
                </Form>
            </Spin >
            {/* 裁剪功能 */}
            < AntdCropper
                imgSrc={ImgSrc}
                oriFile={orifile}
                visible={crovisble}
                callcancel={() => {
                    setcrovisble(false)
                }}
                callok={(afterImg: any) => {
                    UpImage(afterImg, () => {
                        setcrovisble(false)
                    })
                }}
                ratio={1}
            />
            <LgDrawer
                className="myEnroll_drawer"
                style={{ top: 48 }}
                type={"right"}
                visible={popLayer01}
                closeBtn={() => { setPopLayer01(false); }}
                checkBtn={() => { setPopLayer01(false); }}
                title={popData?.planName}
                width={"70%"}
            >
                <>
                    <Spin spinning={planLoading}>
                        <PlanDetail item={planData} />
                    </Spin>
                </>
            </LgDrawer>
        </div >
    )
})

export default RegisterPop
